"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionDetails_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Transaction_1 = require("./Transaction");
var TransactionDetails_Factory = /** @class */ (function () {
    function TransactionDetails_Factory() {
    }
    TransactionDetails_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            AdjustedTransactionTypeCode: model.AdjustedTransactionTypeCode,
            CodeDescription: model.CodeDescription,
            Description: model.Description,
            LedgerCodeDescription: model.LedgerCodeDescription,
            LedgerDescription: model.LedgerDescription,
            RecordId: model.RecordId,
            Transaction: Transaction_1.Transaction_Factory.CreateIncoming(model.Transaction),
        };
        return result;
    };
    TransactionDetails_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            AdjustedTransactionTypeCode: model.AdjustedTransactionTypeCode,
            CodeDescription: model.CodeDescription,
            Description: model.Description,
            LedgerCodeDescription: model.LedgerCodeDescription,
            LedgerDescription: model.LedgerDescription,
            RecordId: model.RecordId,
            Transaction: Transaction_1.Transaction_Factory.CreateOutgoing(model.Transaction),
        };
        return result;
    };
    return TransactionDetails_Factory;
}());
exports.TransactionDetails_Factory = TransactionDetails_Factory;
